import * as React from 'react'
import ContentCard from '../sharedComponents/ContentCard'

export interface IContentCardBlock {
  content: {
    link: string
    heading: string
    imageUrl: string
    imageAltText: string
    teaser: {
      Value: string
    }
    LinkLabel: string
  }
}

function ContentCardBlock({ content }: IContentCardBlock) {
  return (
    <ContentCard
      index={1}
      link={content.link}
      heading={content.heading}
      imageUrl={content.imageUrl}
      imageAltText={content.imageAltText}
      teaser={content.teaser.Value}
      linkLabel={content.LinkLabel}
    />
  )
}

export default ContentCardBlock
